// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import DigilockerLauncher from '../src/components/DigilockerLauncher';
import DLVerificationForm from './components/DLVerificationForm';
import DigilockerRedirect from './components/DigilockerRedirect';
import ConsentPage from './pages/ConsentPage';
import SDKRedirect from './pages/SDKRedirect';

const Home = () => (
  <div style={{ padding: '2rem' }}>
    <h1>Welcome to EarthID Digilocker Demo</h1>
    <p>
      <Link to="/digilocker">
        <button style={{ padding: '10px 20px' }}>Launch Digilocker</button>
      </Link>
    </p>
  </div>
);

const RedirectHandler = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h2>🔁 Redirect Page</h2>
      <p>This page was triggered after the Digilocker SDK closed.</p>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/digilocker" element={<DigilockerLauncher />} />
        <Route path="/redirect" element={<RedirectHandler />} />
        <Route path="/verify-dl" element={<DLVerificationForm />} />
        <Route path="/digilocker-redirect" element={<DigilockerRedirect />} />
        {/* <Route path="/digilocker-redirect" element={<RedirectHandler />} /> */}

        <Route path="/sdk/:req_id" element={<ConsentPage />} />
        <Route path="/redirect/:req_id" element={<SDKRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
